<template>
  <div class="warning card-item">
    <div class="subtitle">
      预警级别
    </div>
    <table border="0" cellspacing="0" cellpadding="0">
      <thead>
        <tr>
          <th style="width: 100px;">
            <div class="cell">种类</div>
          </th>
          <th style="width: 80px;">
            <div class="cell">预警级别</div>
          </th>
          <th>
            <div class="cell text-center">
              近期统计
            </div>
          </th>
          <!-- <th>
            <div class="cell text-center">今日</div>
          </th>
          <th>
            <div class="cell text-center">昨日</div>
          </th> -->
        </tr>
      </thead>

      <tbody ref="scroller" :style="`height: ${height - 42}px;`">
        <tr v-for="item in data" :key="item.id">
          <td style="width:100px;">
            <el-tooltip
              class="item"
              effect="light"
              placement="right"
              :content="item.category"
            >
              <div class="cell">{{ item.category }}</div>
            </el-tooltip>
          </td>
          <td style="width:80px;">
            <div class="cell text-center">
              {{ getFigureText(item.figure) }}
            </div>
          </td>
          <!-- <td>
            <div class="cell text-center">{{ item.today }}</div>
          </td>
          <td>
            <div class="cell text-center">{{ item.yesterday }}</div>
          </td> -->
          <td>
            <div class="cell text-center">{{ item.summary || 0 }}</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    loading: Boolean,
    height: Number,
    data: Array
  },
  data() {
    return {
      timer: null,
      index: 0
    }
  },
  methods: {
    getFigureText(v) {
      return v < 35 ? '低' : v < 60 ? '中' : v < 80 ? '高' : '重'
    },
    scrollTo() {
      let el = this.$refs.scroller
      if (!el) return
      if (this.index === 0) {
        el.scrollTo(0, 0)
        clearInterval(this.timer)
        this.index++
        setTimeout(() => {
          this.timer = setInterval(this.scrollTo, 10)
        }, 2000)
      } else {
        let height = this.data.length * 34 - el.offsetHeight
        let y = this.index * 0.2
        if (y > height) {
          clearInterval(this.timer)
          this.index = 0
          setTimeout(() => {
            this.timer = setInterval(this.scrollTo, 10)
          }, 2000)
        } else {
          el.scrollTo(0, y)
          this.index++
        }
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  watch: {
    data(cur, prev) {
      let height = this.data.length * 34 - this.$refs.scroller.offsetHeight
      if (height > 0) {
        this.index = 0
        if (!prev.length) {
          clearInterval(this.timer)
          this.timer = setInterval(this.scrollTo, 10)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.warning {
  overflow: hidden;
  table {
    padding: 0 20px;
    width: 100%;
    text-align: left;
    thead {
      background-color: #84aaf15e;
      border: none;
    }
    th,
    td {
      padding: 8px 0;
      box-sizing: border-box;
    }
    tbody {
      display: block;
      // overflow-y: hidden;
      overflow-y: hidden;
    }

    tr {
      display: table;
      width: 100%;
      table-layout: fixed;
      text-align: center;
    }
    tbody tr:nth-child(even) td,
    tbody tr:nth-child(even) td {
      background-color: rgba(20, 53, 114, 0.5);
    }

    .cell {
      padding: 0 8px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      text-align: left;
    }
    .cell.text-center {
      text-align: center;
    }
  }
}
</style>
